import type { SlideId } from '@/tenant/TenantConfig'

import { key, read } from '@/lib/storage'
import type { Category, EvolutionTier } from '@/milestones/types'

export interface PersistedSettings {
  theme: 'light' | 'dark' | 'auto'
  locale: 'cs' | 'en'
  slideIntervalSec: number | null
  soundEnabled: boolean
  soundVolume: number
  quietHoursFrom: number
  quietHoursTo: number
  perSlideOverrides: Partial<Record<SlideId, number>>
  
  debugTiers: Partial<Record<Category, EvolutionTier>>
}

export const SETTINGS_KEY = key<PersistedSettings>('settings', 1)

export function readSettings(): PersistedSettings | null {
  return read(SETTINGS_KEY)
}

export const DEFAULT_SETTINGS: PersistedSettings = {
  theme: 'dark',
  locale: 'cs',
  slideIntervalSec: null,
  soundEnabled: true,
  soundVolume: 0.6,
  quietHoursFrom: 22,
  quietHoursTo: 8,
  perSlideOverrides: {},
  debugTiers: {},
}
